window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
    init: function () {
        this.Basic.init();
    },
    Basic: {
        init: function () {
            this.smoothScroll();
            this.sticky_header();
            this.slideshowSwiper();
            this.collapsibleContent();
            this.marqueeScroller();
            this.videLoad();
        },
        sticky_header: function () {
            var header = document.querySelector('[data-sticky-type="always"]');

            if (header != null) {
                onScroll = () => {
                    var scrolledPage = Math.round(window.pageYOffset);
                    if (scrolledPage > 80) {
                        header.classList.add('sticky');
                    } else {
                        header.classList.remove('sticky');
                    }
                }
                document.addEventListener('scroll', onScroll);
            }
        },
        smoothScroll: function () {
            document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#recover"]):not([href="#login"])').forEach(a => {
                a.addEventListener('click', function (e) {
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
                        if (target) {
                            e.preventDefault();
                            window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
                            setTimeout(() => {
                                target.focus();
                                if (!target.matches(':focus')) {
                                    target.setAttribute('tabindex', '-1');
                                    target.focus();
                                }
                            }, 600);
                        }
                    }
                });
            });

        },
        marqueeScroller: function () {
            if (!customElements.get("marquee-content")) {
                class Marquee extends HTMLElement {
                    constructor() {
                        super();
                    }
                    connectedCallback() {
                        this.init();
                    }
                    calculationPaddingSection() {
                        (this.heightSection = this.offsetHeight),
                            (this.heightSection =
                                this.heightSection < 18
                                    ? 18
                                    : 96 < this.heightSection
                                        ? 96
                                        : this.heightSection),
                            this.closest(".js-running-content").style.setProperty(
                                "--spacing-padding-block",
                                this.heightSection + "px"
                            );
                    }
                    init() {
                        (this.distance =
                            this.querySelector(".js-marquee-item").offsetWidth),
                            (this.speed = this.dataset.speed),
                            this.style.setProperty(
                                "--marquee-duration",
                                this.distance / this.speed + "s"
                            );
                    }
                }
                customElements.define("marquee-content", Marquee);
            }
        },
        slideshowSwiper: function () {

            class slideshowSwiper extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    this.sliderWrapper = this.querySelector(".slideshow__swiper");

                    let centered_slides =
                        this.sliderWrapper.dataset.centeredslides !== undefined
                            ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
                            : undefined;
                    let effect_fade =
                        this.sliderWrapper.dataset.effectfade !== undefined
                            ? JSON.parse(this.sliderWrapper.dataset.effectfade)
                            : undefined;
                    let next = this.querySelector(".swiper-button-next");
                    let prev = this.querySelector(".swiper-button-prev");
                    let pagination = this.querySelector(".swiper-pagination");
                    let scroll = this.querySelector(".swiper-scrollbar");

                    new Swiper(this.sliderWrapper, {
                        effect: effect_fade ? "fade" : "slide",
                        centeredSlides: centered_slides ? centered_slides : false,
                        slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
                        spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
                        grabCursor: false,
                        horizontal: true,
                        watchSlidesProgress: true,
                        draggable: !0,
                        autoHeight: !1,
                        watchOverflow: !0,
                        threshold: 10,
                        freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
                        loop: JSON.parse(this.sliderWrapper.dataset.loop),
                        speed: 700,
                        mousewheel: {
                            forceToAxis: true,
                        },
                        autoplay: {
                            enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
                            disableOnInteraction: false,
                            delay: parseInt(this.sliderWrapper.dataset.delay),
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                        pagination: {
                            el: pagination,
                            clickable: true,
                        },
                        scrollbar: {
                            el: scroll,
                            draggable: true,
                        },
                        breakpoints: {
                            359: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
                            },
                            768: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
                            },
                            1024: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
                            },
                        },
                    });
                }
            }
            customElements.define("slideshow-swiper", slideshowSwiper);

            class slideshowVertical extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    this.sliderVertical = this.querySelector(".slideshow__vertical");

                    let centered_slides =
                        this.sliderVertical.dataset.centeredslides !== undefined
                            ? JSON.parse(this.sliderVertical.dataset.centeredslides)
                            : undefined;
                    let effect_fade =
                        this.sliderVertical.dataset.effectfade !== undefined
                            ? JSON.parse(this.sliderVertical.dataset.effectfade)
                            : undefined;
                    let next = this.querySelector(".swiper-button-next");
                    let prev = this.querySelector(".swiper-button-prev");
                    let pagination = this.querySelector(".swiper-pagination");
                    let scroll = this.querySelector(".swiper-scrollbar");

                    new Swiper(this.sliderVertical, {
                        effect: effect_fade ? "fade" : "slide",
                        centeredSlides: centered_slides ? centered_slides : false,
                        slidesPerView: parseInt(this.sliderVertical.dataset.slidesmobile),
                        spaceBetween: parseInt(this.sliderVertical.dataset.mobilespace),
                        direction: 'horizontal',
                        freeMode: JSON.parse(this.sliderVertical.dataset.freemode),
                        loop: JSON.parse(this.sliderVertical.dataset.loop),
                        speed: 700,

                        autoplay: {
                            enabled: JSON.parse(this.sliderVertical.dataset.autoplay),
                            disableOnInteraction: false,
                            delay: parseInt(this.sliderVertical.dataset.delay),
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                        pagination: {
                            el: pagination,
                            clickable: true,
                        },
                        scrollbar: {
                            el: scroll,
                            draggable: true,
                        },
                        breakpoints: {
                            359: {
                                slidesPerView: parseFloat(this.sliderVertical.dataset.slidesmobile),
                                spaceBetween: parseInt(this.sliderVertical.dataset.mobilespace),
                                direction: 'horizontal',
                            },
                            768: {
                                slidesPerView: parseFloat(this.sliderVertical.dataset.slidestab),
                                spaceBetween: parseInt(this.sliderVertical.dataset.tabspace),
                            },
                            1024: {
                                slidesPerView: parseFloat(this.sliderVertical.dataset.slidesdesktop),
                                spaceBetween: parseInt(this.sliderVertical.dataset.desktopspace),
                                direction: 'vertical',
                            },
                        },
                    });
                }
            }
            customElements.define("vertical-swiper", slideshowVertical);

        },
        videLoad: function () {
            class THMLazyLoadingVideo extends HTMLElement {
                constructor() {
                    super(),
                        (this.iframe = this.querySelector("iframe")),
                        (this.template = this.querySelector("template")),
                        (this.isMouseenter = !1);
                }
                loadVideo() {
                    var t;
                    this.iframe &&
                        (this.iframe.setAttribute("src", this.iframe.getAttribute("data-src")),
                            this.iframe.addEventListener(
                                "load",
                                function () {
                                    "youtube" == this.dataVideoType &&
                                        this.iframe.contentWindow.postMessage(
                                            '{"event":"command","func":"playVideo","args":""}',
                                            "*"
                                        ),
                                        "vimeo" == this.dataVideoType &&
                                        this.iframe.contentWindow.postMessage('{"method":"play"}', "*");
                                }.bind(this)
                            )),
                        "local_video" == this.dataVideoType &&
                        ((this.local_video = this.querySelector("video")),
                            (t = this.local_video.querySelector("source").getAttribute("data-src")),
                            (this.local_video.src = t));
                }
                execute() {
                    Shopify.designMode
                        ? this.loadVideo()
                        : (["mousemove", "touchstart"].forEach(
                            function (t) {
                                THMHelper.qs("body").addEventListener(
                                    t,
                                    function (t) {
                                        this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                                    }.bind(this),
                                    { once: !0 }
                                );
                            }.bind(this)
                        ),
                            window.addEventListener(
                                "scroll",
                                function (t) {
                                    this.isMouseenter || this.loadVideo(), (this.isMouseenter = !0);
                                }.bind(this),
                                { once: !0 }
                            ));
                }
                static get observedAttributes() {
                    return ["data-video-type", "data-video-id"];
                }
                set dataVideoType(t) {
                    this.setAttribute("data-video-type", t);
                }
                get dataVideoType() {
                    return this.getAttribute("data-video-type");
                }
                set dataVideoId(t) {
                    this.setAttribute("data-video-id", t);
                }
                get dataVideoId() {
                    return this.getAttribute("data-video-id");
                }
                attributeChangedCallback(t, e, s) {
                    e !== s && this.execute();
                }
                connectedCallback() {
                    this.execute();
                }
                disconnectedCallback() { }
            }
            customElements.define("thm-load-video", THMLazyLoadingVideo);

            class THMLoadMedia extends HTMLElement {
                constructor() {
                    super(),
                        (this.$ = this.querySelector.bind(this)),
                        (this.sectionID = this.dataset.sectionId),
                        (this.idVideo = this.dataset.idVideo),
                        (this.typeVideo = this.dataset.type),
                        (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
                        (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
                        (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
                        (this.playPauseButton = this.$(".video-play-pause-button")),
                        (this.trigger = this.$(".js-load-media-trigger")),
                        this.trigger && this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));

                    if (this.playPauseButton) {
                        this.playPauseButton.addEventListener("click", this.togglePlayPauseVideo.bind(this));
                    }
                }


                togglePlayPauseVideo() {
                    this.classList.add("playing");
                    this.loadContent();

                    const video = this.$(".js-media-item-video");

                    if (!video) return;

                    // First time play: pause others, play this
                    if (video.paused || video.ended) {
                        this.pauseAllVideo(video);
                        video.play();
                        this.updatePlayPauseIcon(true);
                    } else {
                        video.pause();
                        this.updatePlayPauseIcon(false);
                    }

                    // ✅ If YouTube player is present
                    if (this.player && typeof this.player.getPlayerState === "function") {
                        const state = this.player.getPlayerState();
                        if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
                            this.pauseAllVideo(this.player);
                            this.player.playVideo();
                            this.updatePlayPauseIcon(true);
                        } else if (state === YT.PlayerState.PLAYING) {
                            this.player.pauseVideo();
                            this.updatePlayPauseIcon(false);
                        }
                    }



                }

                updatePlayPauseIcon(isPlaying) {
                    const playIcon = this.playPauseButton?.querySelector(".video-play-icon");
                    const pauseIcon = this.playPauseButton?.querySelector(".video-pause-icon");

                    if (!playIcon || !pauseIcon) return;

                    if (isPlaying) {
                        playIcon.style.display = "none";
                        pauseIcon.style.display = "inline";
                    } else {
                        playIcon.style.display = "inline";
                        pauseIcon.style.display = "none";
                    }
                }



                handlePlayVideo() {
                    this.classList.add("playing");
                    this.loadContent();
                    const t = this.querySelector(".js-media-item-video");
                    t &&
                        t.addEventListener("play", () => {
                            this.pauseAllVideo(t), t.play();
                        });
                }
                onYouTubeIframeAPIReady() {
                    if ("undefined" != typeof YT && void 0 !== YT.Player)
                        try {
                            this.player = new YT.Player(this.eleVideo, {
                                videoId: this.idVideo,
                                playerVars: { playsinline: 1 },
                                events: {
                                    onReady: this.onPlayerYTReady,
                                    onStateChange: this.onPlayerStateYTChange,
                                },
                            });
                        } catch (t) {
                            console.error("Lỗi khi tạo trình phát YouTube:", t);
                        }
                    else {
                        var t = document.createElement("script"),
                            e =
                                ((t.src = "https://www.youtube.com/iframe_api"),
                                    (t.onload = () => {
                                        this.onYouTubeIframeAPIReady();
                                    }),
                                    document.getElementsByTagName("script")[0]);
                        e.parentNode.insertBefore(t, e);
                    }
                }
                onVimeoIframeAPIReady() {
                    if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
                        try {
                            var t = { id: this.idVideo, autoplay: 1 };
                            (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                                this.playerVimeo.on("play", () => {
                                    this.pauseAllVideo(this.playerVimeo);
                                });
                        } catch (t) {
                            console.error("Lỗi khi tạo trình phát Vimeo:", t);
                        }
                    else {
                        var t = document.createElement("script"),
                            e =
                                ((t.src = "https://player.vimeo.com/api/player.js"),
                                    (t.onload = () => {
                                        this.onVimeoIframeAPIReady();
                                    }),
                                    document.getElementsByTagName("script")[0]);
                        e.parentNode.insertBefore(t, e);
                    }
                }
                onPlayerYTReady = () => {
                    this.pauseAllVideo(this.player), this.player.playVideo();
                };
                // onPlayerStateYTChange = (t) => {
                //   1 == t.data && this.onPlayerPlay();
                // };

                onPlayerStateYTChange = (t) => {
                    const state = t.data;

                    if (state === YT.PlayerState.PLAYING) {
                        this.onPlayerPlay(); // pause other videos
                        this.updatePlayPauseIcon(true); // 👈 show pause icon
                    } else if (
                        state === YT.PlayerState.PAUSED ||
                        state === YT.PlayerState.ENDED
                    ) {
                        this.updatePlayPauseIcon(false); // 👈 show play icon
                    }
                };



                onPlayerPlay = () => {
                    this.pauseAllVideo(this.player);
                };
                loadContent() {
                    if (!this.getAttribute("loaded")) {
                        if (this.$("template")) {
                            var t = this.$("template").content.firstElementChild.cloneNode(!0);
                            this.appendChild(t),
                                this.isLoaded(!0),
                                this.trigger && this.trigger.remove();

                            // 🔽 ADD HERE AFTER APPENDING VIDEO
                            const video = this.$(".js-media-item-video");
                            if (video && !video.hasAttribute("data-listeners-added")) {
                                video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                                video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                                video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                                video.setAttribute("data-listeners-added", "true");
                            }

                        } else {
                            if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
                            else {
                                if ("vimeo" != this.typeVideo) return !0;
                                this.onVimeoIframeAPIReady();
                            }
                            this.trigger?.classList.add("d-none"),
                                this.$(".js-media-item").classList.add("d-flex");

                            // 🔽 ALSO ADD HERE in case video is not loaded via <template>
                            const video = this.$(".js-media-item-video");
                            if (video && !video.hasAttribute("data-listeners-added")) {
                                video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                                video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                                video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                                video.setAttribute("data-listeners-added", "true");
                            }

                        }
                        return !0;
                    }
                }
                pauseAllVideo(e) {
                    THMHelper.qsa(
                        ".js-product-media-deferred-video:has([data-type='youtube']"
                    ).forEach((t) => {
                        t.player && e !== t.player && t.player?.pauseVideo();
                    }),
                        THMHelper.qsa(
                            ".js-product-media-deferred-video:has([data-type='vimeo'])"
                        ).forEach((t) => {
                            t.playerVimeo !== e && t.playerVimeo?.pause();
                        }),
                        THMHelper.qsa(".js-media-item-video").forEach((t) => {
                            t !== e && t.pause();
                        });
                }
                isLoaded(t) {
                    t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
                }
            }
            customElements.define("thm-load-media", THMLoadMedia);
        },
        collapsibleContent: function () {

            if (!customElements.get("collapsible-content")) {
                class collapsibleContent extends HTMLElement {
                    constructor() {
                        super();
                        this.disclosure = this.querySelector('details');

                        this.toggle = this.querySelector('summary');
                        this.panel = this.toggle.nextElementSibling;
                        this.init();
                    }

                    init() {
                        // Check if the content element has a CSS transition.
                        if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
                            this.toggle.addEventListener('click', this.handleToggle.bind(this));
                            this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
                        }
                    }

                    /**
                     * Handles 'click' events on the summary element.
                     * @param {object} evt - Event object.
                     */
                    handleToggle(evt) {
                        evt.preventDefault();

                        if (!this.disclosure.open) {
                            this.open();

                        } else {
                            this.close();

                        }
                    }


                    /**
                     * Handles 'transitionend' events on the details element.
                     * @param {object} evt - Event object.
                     */
                    handleTransitionEnd(evt) {
                        if (evt.target !== this.panel) return;

                        if (this.disclosure.classList.contains('is-closing')) {
                            this.disclosure.classList.remove('is-closing');
                            this.disclosure.open = false;
                        }

                        this.panel.removeAttribute('style');
                    }

                    /**
                     * Adds inline 'height' style to the content element, to trigger open transition.
                     */
                    addContentHeight() {
                        this.panel.style.height = `${this.panel.scrollHeight}px`;
                    }

                    /**
                     * Opens the details element.
                     */
                    open() {
                        // Set content 'height' to zero before opening the details element.
                        this.panel.style.height = '0';

                        // Open the details element
                        this.disclosure.open = true;

                        // Set content 'height' to its scroll height, to enable CSS transition.
                        this.addContentHeight();
                    }

                    /**
                     * Closes the details element.
                     */
                    close() {
                        // Set content height to its scroll height, to enable transition to zero.
                        this.addContentHeight();

                        // Add class to enable styling of content or toggle icon before or during close transition.
                        this.disclosure.classList.add('is-closing');

                        // Set content height to zero to trigger the transition.
                        // Slight delay required to allow scroll height to be applied before changing to '0'.
                        setTimeout(() => {
                            this.panel.style.height = '0';
                        });
                    }
                }
                customElements.define('collapsible-content', collapsibleContent);
            }
        }
    },
};


document.addEventListener('DOMContentLoaded', function () {
    Thm.init();
});




if (!customElements.get("collapsible-mobilecontent")) {
    class CollapsibleMobileContent extends HTMLElement {
        constructor() {
            super();
            this.detailsList = Array.from(this.querySelectorAll('details'));
            this.isMobile = window.innerWidth < 768;

            this.boundHandleResize = this.handleResize.bind(this);
            this.boundToggleHandlers = new Map();

            this.init();
            window.addEventListener('resize', this.boundHandleResize);
        }

        init() {
            if (this.isMobile) {
                this.enableAccordion();
            } else {
                this.disableAccordion();
            }
        }

        handleResize() {
            const nowMobile = window.innerWidth < 768;
            if (nowMobile !== this.isMobile) {
                this.isMobile = nowMobile;
                if (this.isMobile) {
                    this.enableAccordion();
                } else {
                    this.disableAccordion();
                }
            }
        }

        enableAccordion() {
            this.detailsList.forEach(details => {
                const toggle = details.querySelector('summary');
                const panel = toggle.nextElementSibling;

                // Reset for mobile mode
                panel.style.height = '0';
                details.open = false;
                details.classList.remove('is-closing');

                // Create click handler for this details
                const handler = (evt) => {
                    evt.preventDefault();
                    if (!details.open) {
                        // Opening animation
                        panel.style.height = '0';
                        details.open = true;
                        requestAnimationFrame(() => {
                            panel.style.height = `${panel.scrollHeight}px`;
                        });
                    } else {
                        // Closing animation
                        panel.style.height = `${panel.scrollHeight}px`;
                        details.classList.add('is-closing');
                        setTimeout(() => {
                            panel.style.height = '0';
                        }, 10);
                    }
                };

                if (!this.boundToggleHandlers.has(details)) {
                    toggle.addEventListener('click', handler);
                    this.boundToggleHandlers.set(details, handler);

                    // Transition end cleanup
                    panel.addEventListener('transitionend', (evt) => {
                        if (evt.target !== panel) return;
                        if (details.classList.contains('is-closing')) {
                            details.classList.remove('is-closing');
                            details.open = false;
                            panel.style.height = '';
                        }
                    });
                }
            });
        }

        disableAccordion() {
            this.detailsList.forEach(details => {
                const toggle = details.querySelector('summary');
                const panel = toggle.nextElementSibling;

                // Remove click handlers if present
                const handler = this.boundToggleHandlers.get(details);
                if (handler) {
                    toggle.removeEventListener('click', handler);
                    this.boundToggleHandlers.delete(details);
                }

                // Reset styles for desktop view
                panel.style.height = '';
                details.classList.remove('is-closing');
                details.open = true;
            });
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.boundHandleResize);
            this.detailsList.forEach(details => {
                const toggle = details.querySelector('summary');
                const handler = this.boundToggleHandlers.get(details);
                if (handler) {
                    toggle.removeEventListener('click', handler);
                }
            });
            this.boundToggleHandlers.clear();
        }
    }

    customElements.define('collapsible-mobilecontent', CollapsibleMobileContent);
}




class LookModal extends HTMLElement {
    constructor() {
        super();
        this.hotspots = null;
        this.modal = null;
        this.pagination = null;
        this.closeBtn = null;
        this.lookSlider = null;
        this.activeIndex = 0;
        this.isMobile = false;
    }

    connectedCallback() {
        this.hotspots = this.querySelectorAll('.look__dot__holder');
        this.modal = this.querySelector('.look-flex__inner--product');
        this.pagination = this.querySelector(".swiper-pagination");
        this.closeBtn = this.querySelector('.look__holder__close');

        if (!this.modal || !this.hotspots.length) {
            console.warn('LookModalSlider: Required elements not found inside component');
            return;
        }

        // // ---- Call update once on init ----
        this.updateIsMobile();

        // // ---- Bind resize ----
        window.addEventListener('resize', () => this.updateIsMobile());

        // // ---- Init Swiper ----
        this.lookSlider = new Swiper(this.querySelector('.look__slider'), {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            pagination: {
                el: this.pagination,
                clickable: true
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        });

        if (!this.isMobile) {
            this.modal.classList.add('is-expanded');
            this.hotspots[this.activeIndex].classList.add('is-active');
            this.lookSlider.slideToLoop ? this.lookSlider.slideToLoop(this.activeIndex, 0, false) : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
        }


        // ---- Hotspot click ----

        this.hotspots.forEach(hotspot => {
            hotspot.addEventListener('click', () => {
                const index = parseInt(hotspot.dataset.index, 10);

                if (hotspot.classList.contains('is-active')) {
                    this.closeModal();
                } else {
                    this.hotspots.forEach(h => h.classList.remove('is-active'));
                    hotspot.classList.add('is-active');
                    this.activeIndex = index;
                    this.modal.classList.add('is-expanded');
                    this.lookSlider.slideToLoop ? this.lookSlider.slideToLoop(index, 500) : this.lookSlider.slideTo(index, 500);
                }
            });
        });

        // ---- Close button ----
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', () => this.closeModal());
        }
    }

    updateIsMobile() {
        if (!this.modal) return;

        const prevMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 768;

        // ---- Desktop → Mobile ----
        if (!prevMobile && this.isMobile) {
            this.modal.classList.remove('is-expanded');
            this.hotspots.forEach(h => h.classList.remove('is-active'));
            this.activeIndex = 0;
        }

        // ---- Mobile → Desktop ----
        if (prevMobile && !this.isMobile) {
            const anyActive = Array.from(this.hotspots).some(h => h.classList.contains('is-active'));
            if (!anyActive) {
                this.hotspots[0].classList.add('is-active');
                this.modal.classList.add('is-expanded');
                this.activeIndex = 0;
                this.lookSlider.slideToLoop
                    ? this.lookSlider.slideToLoop(this.activeIndex, 0, false)
                    : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
            }
        }
    }

    closeModal() {
        this.modal.classList.remove('is-expanded');
        this.hotspots.forEach(h => h.classList.remove('is-active'));
        this.activeIndex = 0;
        this.lookSlider.slideToLoop
            ? this.lookSlider.slideToLoop(this.activeIndex, 500) // smooth back
            : this.lookSlider.slideTo(this.activeIndex, 500);
    }
}

customElements.define('look-modal', LookModal);




class upsellVariantSelects extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantInput();
    }


    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });


    }


    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const container = this.closest('.cart-drawer__upsell-item');
        const form = container.querySelector('form');

        console.log("Tress",  this.currentVariant.id);

        if (!form) return;
        const variantInput = form.querySelector('input[name="id"]');
        if (!variantInput) return;

        if (this.currentVariant) {
            variantInput.value = this.currentVariant.id;
        }

    }

    getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('upsell-variant-selects', upsellVariantSelects);
